import React, { useState } from "react";
import styled from "styled-components";


const AccordionWrapper = styled.div`
	.accordion-div {
		width: 100%;
		padding: 1rem;
	}

	.accordion-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1rem 1rem 0;
		border-bottom: 1px solid #cdcece;
	}

	.mainHeader {
		color: #000;
		font-weight: 500;
		font-size: 1.5rem;
	}

	.accordion-content {
		padding: 0 1rem;
	}

	.mainContent {
		padding: 0;
	}

	.arrowIcon {
		border: 3px solid #545454;
		border-width: 0 3px 3px 0;
		margin: 3px;
		padding: 3px;
	}

	.arrowIconUp {
		transform: rotate(-135deg) !important;
		-webkit-transform: rotate(-135deg) !important;
	}

	.arrowIconDown {
		transform: rotate(45deg) !important;
		-webkit-transform: rotate(45deg) !important;
	}
`;

const Accordion = ({
	title,
	content,
	headerClassName = "",
	contentClassName = "",
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleAccordion = () => {
		setIsOpen(!isOpen);
	};

	const changeArrowIcon = () => {
		var arrowList = document.getElementById("arrowIcon").classList;
		// // console.log("before: ", arrowList);
		// // console.log("before-1: ", dropList);
		if (arrowList.contains("arrowIconUp")) {
			arrowList.remove("arrowIconUp");
			arrowList.add("arrowIconDown");
		} else {
			arrowList.remove("arrowIconDown");
			arrowList.add("arrowIconUp");
		}
		// if (dropList.contains("show")) {
		// 	setTimeout(() => {
		// 		dropList.remove("show");
		// 	}, 100);
		// } else {
		// 	dropList.add("show");
		// }
		// document.getElementById("myDropdown").classList = dropList;
		document.getElementById("arrowIcon").classList = arrowList;
		// console.log("after: ", arrowList);
		// console.log("after-1: ", dropList);
	};

	return (
		<>
			<AccordionWrapper>
				<div className="accordion-div">
					<div
						className={`accordion-header ${headerClassName}`}
						onClick={toggleAccordion}
					>
						<span>{title}</span>
						<span
							className={`arrowIcon ${
								isOpen ? "arrowIconUp" : "arrowIconDown"
							}`}
						></span>
					</div>
					{isOpen && (
						<div className={`accordion-content ${contentClassName}`}>
							<p>{content}</p>
						</div>
					)}
				</div>
			</AccordionWrapper>
		</>
	);
};

export default Accordion;
